import { render, staticRenderFns } from "./pieChartTotal1.vue?vue&type=template&id=03b87440&scoped=true&"
import script from "./pieChartTotal1.vue?vue&type=script&lang=js&"
export * from "./pieChartTotal1.vue?vue&type=script&lang=js&"
import style0 from "./pieChartTotal1.vue?vue&type=style&index=0&id=03b87440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b87440",
  null
  
)

export default component.exports